import { render, staticRenderFns } from "./SettingsCustomisePage.vue?vue&type=template&id=18583f82"
import script from "./SettingsCustomisePage.vue?vue&type=script&lang=ts"
export * from "./SettingsCustomisePage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsCustomisePage.vue?vue&type=style&index=0&id=18583f82&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports